
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as LockIcon } from "../fontello/icons/svg/ic_lock.svg"


const Lock = ({ ...props }) => (
  <SvgIcon
    component={LockIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Lock
